'use client';

import Banner from './Banner';
import Square from './Square';
import SquareAnimate from './SquareAnimate';

interface Props {
  variant: 'banner' | 'square' | 'square-animate';
  className?: string;
}

const logos = {
  banner: <Banner />,
  square: <Square />,
  'square-animate': <SquareAnimate />,
};

export default function Logo({ variant = 'square', className }: Props) {
  // console.log(variant);
  // TODO: Debug constant rerenders
  return <div className={className}>{logos[variant]}</div>;
}
